"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOPPTransactionResponse = void 0;
var IOPPTransactionResponse;
(function (IOPPTransactionResponse) {
    let PaymentMethodOptionEnum;
    (function (PaymentMethodOptionEnum) {
        PaymentMethodOptionEnum["FULLPAN"] = "FULL_PAN";
        PaymentMethodOptionEnum["NETWORKTOKEN"] = "NETWORK_TOKEN";
    })(PaymentMethodOptionEnum = IOPPTransactionResponse.PaymentMethodOptionEnum || (IOPPTransactionResponse.PaymentMethodOptionEnum = {}));
    let TransactionOptionEnum;
    (function (TransactionOptionEnum) {
        TransactionOptionEnum["MERCHANTINITIATED"] = "MERCHANT_INITIATED";
        TransactionOptionEnum["SUBSCRIPTION"] = "SUBSCRIPTION";
        TransactionOptionEnum["CUSTOMERINITIATED"] = "CUSTOMER_INITIATED";
    })(TransactionOptionEnum = IOPPTransactionResponse.TransactionOptionEnum || (IOPPTransactionResponse.TransactionOptionEnum = {}));
    let TransactionTypeEnum;
    (function (TransactionTypeEnum) {
        TransactionTypeEnum["INITIAL"] = "INITIAL";
        TransactionTypeEnum["RECURRING"] = "RECURRING";
        TransactionTypeEnum["ONETIME"] = "ONE_TIME";
    })(TransactionTypeEnum = IOPPTransactionResponse.TransactionTypeEnum || (IOPPTransactionResponse.TransactionTypeEnum = {}));
    let StateEnum;
    (function (StateEnum) {
        StateEnum["OPEN"] = "OPEN";
        StateEnum["PENDING"] = "PENDING";
        StateEnum["SUCCESS"] = "SUCCESS";
        StateEnum["CANCELLED"] = "CANCELLED";
        StateEnum["FAILED"] = "FAILED";
        StateEnum["REFUNDED"] = "REFUNDED";
        StateEnum["PARTIALLYREFUNDED"] = "PARTIALLY_REFUNDED";
        StateEnum["INDISPUTE"] = "IN_DISPUTE";
        StateEnum["DISPUTESOLVED"] = "DISPUTE_SOLVED";
    })(StateEnum = IOPPTransactionResponse.StateEnum || (IOPPTransactionResponse.StateEnum = {}));
})(IOPPTransactionResponse || (exports.IOPPTransactionResponse = IOPPTransactionResponse = {}));
//# sourceMappingURL=types.js.map